// BuyButton.tsx

import React from 'react';
import style from './style.module.scss';
import Icon from 'components/Icon';
import {Quantity} from './Quantity';
import cs from 'classnames';
import {IProductSnippet} from 'shared/types/productSnippet.types';
import {ButtonV3} from 'components/ButtonV3';

type TBuyButtonProps = Pick<
    IProductSnippet['cart'],
    'onGoToCart' | 'quantity' | 'onRemoveOne' | 'onAddOne' | 'onQuantityChange' | 'isPendingQuantityChange'
>;

export const BuyButton = (props: TBuyButtonProps) => {
    const {onAddOne, onRemoveOne, onQuantityChange, isPendingQuantityChange, onGoToCart, quantity} = props;

    return 0 < quantity ? (
        <BuyButton.Counter
            onAddOne={onAddOne}
            onRemoveOne={onRemoveOne}
            onGoToCart={onGoToCart}
            isPendingQuantityChange={isPendingQuantityChange}
            quantity={quantity}
            onQuantityChange={onQuantityChange}
        />
    ) : (
        <BuyButton.AddToCart onAddOne={onAddOne} isPendingQuantityChange={isPendingQuantityChange} />
    );
};

BuyButton.AddToCart = (props: Pick<TBuyButtonProps, 'onAddOne' | 'isPendingQuantityChange'>) => {
    const {onAddOne, isPendingQuantityChange} = props;

    return (
        <ButtonV3
            isIconButton={true}
            size={'medium'}
            theme={'primary'}
            isLoading={isPendingQuantityChange}
            onClick={onAddOne}
        >
            <Icon icon={'plus'} />
        </ButtonV3>
    );
};

BuyButton.Counter = (props: TBuyButtonProps) => {
    // const {onAddOne, onRemoveOne, onQuantityChange, onGoToCart, isPendingQuantityChange, quantity} = props;
    const {onAddOne, onRemoveOne, onQuantityChange, isPendingQuantityChange, quantity} = props;

    return (
        <div className={cs(style.root)}>
            {/* <ToCartButton className={style.inCart} onClick={onGoToCart} />*/}
            <div className={cs(style.counter)}>
                <ButtonV3
                    isIconButton={true}
                    size={'small'}
                    theme={'tertiary_inv'}
                    onClick={onRemoveOne}
                    disabled={isPendingQuantityChange}
                >
                    <Icon icon={'minus'} />
                </ButtonV3>
                <div className={style.counter__quantity}>
                    <Quantity value={quantity} handleChange={onQuantityChange} isLoading={isPendingQuantityChange} />
                </div>
                <ButtonV3
                    isIconButton={true}
                    size={'small'}
                    theme={'tertiary_inv'}
                    onClick={onAddOne}
                    disabled={isPendingQuantityChange}
                >
                    <Icon icon={'plus'} />
                </ButtonV3>
            </div>
        </div>
    );
};
